import useTypedSelector from 'web-app/react/hooks/use-typed-selector';
import {isOpen} from 'web-app/react/modals-container/types';

export const useFileTaggingFormName = () => {
    const formName = useTypedSelector(
        state => isOpen(state.modals.fileTaggingModal) && state.modals.fileTaggingModal.fileUploadFormName,
    );

    return formName;
};
